import { render } from "./WSelector.vue?vue&type=template&id=efa06a3c&scoped=true"
import script from "./WSelector.vue?vue&type=script&lang=js"
export * from "./WSelector.vue?vue&type=script&lang=js"

import "./WSelector.vue?vue&type=style&index=0&id=efa06a3c&scoped=true&lang=css"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa06a3c"]])

export default __exports__